import { motion } from "framer-motion";

interface FooterProps {
  onHomeClick: () => void;
  onAboutClick: () => void;
  onServicesClick: () => void;
  onGalleryClick: () => void;
  onTestimonialsClick: () => void;
  onAreasClick: () => void;
  onTimelineClick?: () => void;
  onEstimationClick?: () => void;
  onBookingClick?: () => void;
  onContactClick: () => void;
}

const Footer = ({
  onHomeClick,
  onAboutClick,
  onServicesClick,
  onGalleryClick,
  onTestimonialsClick,
  onAreasClick,
  onTimelineClick,
  onEstimationClick,
  onBookingClick,
  onContactClick
}: FooterProps) => {
  return (
    <footer
      className="text-white pt-16 pb-8 relative"
      style={{
        background: "linear-gradient(rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.9)), url('https://images.unsplash.com/photo-1510074377623-8cf13fb86c08?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80') no-repeat center center / cover"
      }}
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="text-center md:text-left"
          >
            <img
              src="logo-e-zez-png-3.png"
              alt="Swiss Welding LLC"
              className="h-32 md:h-24 w-auto mb-6 mx-auto md:mx-0"
            />
            <p className="mb-6 text-center md:text-left">
              Providing premium welding services with Swiss precision and reliability
              throughout Ridgefield, CT and surrounding areas.
            </p>
            <h3 className="font-montserrat font-bold text-lg mb-3 text-red-600 text-center md:text-left">Follow Us</h3>
            <div className="flex space-x-4 justify-center md:justify-start">
              <a href="#" className="text-gray-300 hover:text-red-600 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                </svg>
              </a>
              <a href="#" className="text-gray-300 hover:text-red-600 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z" />
                </svg>
              </a>
              <a href="#" className="text-gray-300 hover:text-red-600 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                </svg>
              </a>
              <a href="#" className="text-gray-300 hover:text-red-600 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0z" />
                </svg>
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            viewport={{ once: true }}
            className="text-center md:text-left"
          >
            <h3 className="font-montserrat font-bold text-lg mb-6 text-red-600 text-center md:text-left">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={onHomeClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={onAboutClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={onServicesClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Our Services
                </button>
              </li>
              <li>
                <button
                  onClick={onGalleryClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={onTestimonialsClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={onAreasClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Areas We Serve
                </button>
              </li>
              <li>
                <button
                  onClick={onTimelineClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Project Timeline
                </button>
              </li>
              <li>
                <button
                  onClick={onEstimationClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Project Estimate
                </button>
              </li>
              <li className="flex justify-center md:justify-start">
                <button
                  onClick={onBookingClick}
                  className="bg-white text-black hover:text-red-600 transition-colors px-3 py-1 rounded"
                >
                  Book Online
                </button>
              </li>
              <li>
                <button
                  onClick={onContactClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-center md:text-left"
          >
            <h3 className="font-montserrat font-bold text-lg mb-6 text-red-600 text-center md:text-left">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={onServicesClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Cable Railing
                </button>
              </li>
              <li>
                <button
                  onClick={onServicesClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Indoor Railing
                </button>
              </li>
              <li>
                <button
                  onClick={onServicesClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Ornamental Work
                </button>
              </li>
              <li>
                <button
                  onClick={onServicesClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Outdoor Railing
                </button>
              </li>
              <li>
                <button
                  onClick={onServicesClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Spiral Stairs
                </button>
              </li>
              <li>
                <button
                  onClick={onServicesClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Stainless Steel
                </button>
              </li>
              <li>
                <button
                  onClick={onServicesClick}
                  className="text-gray-300 hover:text-red-600 transition-colors w-full text-center md:text-left"
                >
                  Steel Fabrication
                </button>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            viewport={{ once: true }}
            className="text-center md:text-left"
          >
            <h3 className="font-montserrat font-bold text-lg mb-6 text-red-600 text-center md:text-left">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start justify-center md:justify-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-red-600 mr-3 mt-1 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span className="text-white text-center md:text-left">4 old mill plain road Danbury 06811 Danbury, CT, United States, Connecticut 06811</span>
              </li>
              <li className="flex items-start justify-center md:justify-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-red-600 mr-3 mt-1 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <span className="text-white text-center md:text-left">(+1) 203 788 8415</span>
              </li>
              <li className="flex items-start justify-center md:justify-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-red-600 mr-3 mt-1 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <span className="text-white text-center md:text-left break-all">customerservice@swissweldingllc.com</span>
              </li>
              <li className="flex items-start justify-center md:justify-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-red-600 mr-3 mt-1 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span className="text-white text-center md:text-left">
                  Mon-Fri: 8:00 AM - 6:00 PM
                  <br />
                  Sat: 9:00 AM - 5:00 PM
                </span>
              </li>
            </ul>
          </motion.div>
        </div>

        <motion.div
          className="border-t border-gray-800 pt-8 mt-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="flex flex-col md:flex-row justify-center md:justify-between items-center text-center md:text-left">
            <p className="text-center md:text-left">
              &copy; {new Date().getFullYear()} Swiss Welding LLC. All rights reserved. |
              <span className="text-gray-400 text-sm ml-2">
                Designed by: <a
                  href="https://blenddesigns.au"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-red-600 hover:text-red-400 transition-colors font-medium underline"
                  title="Visit BlendDesigns Australia - Professional Web Design Services"
                >
                  BlendDesigns Australia
                </a>
              </span>
            </p>
            <p className="mt-4 md:mt-0 text-center md:text-left">
              <a href="/sitemap" className="text-gray-300 hover:text-red-600 transition-colors mr-4">
                Sitemap
              </a>
              <a href="#" className="text-gray-300 hover:text-red-600 transition-colors mr-4">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-300 hover:text-red-600 transition-colors">
                Terms of Service
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;